import { NgModule } from '@angular/core';
import {CommonModule, DatePipe, LowerCasePipe} from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
// module
import { SharedModule } from 'src/app/shared/shared.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FormsModule } from '@angular/forms';
// containers
import { CartComponent } from './containers/cart/cart.component';

const routes: Routes = [{ path: '', component: CartComponent }];

@NgModule({
  declarations: [CartComponent],
  providers: [DatePipe, LowerCasePipe],
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    FormsModule,
    CurrencyMaskModule,
    RouterModule.forChild(routes)
  ]
})
export class CartModule {}
